import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';

interface Props {
  isInbox?: boolean;
  noMargin?: boolean;
  applyDottedText?: boolean;
  removeTitleSpacing?: boolean;
}

const Header = styled.div<Props>`
  padding: 8px 20px 0;
  background-color: var(--background-secondary);
  margin-inline: ${({ isInbox, noMargin }) => (isInbox ? '-8px' : noMargin ? '0' : '-20px')};
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  z-index: 9999;
  width: calc(100vw - 40px);
`;

// Top Section styles
const TopSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
`;

const SubTitle = styled.p`
  width: max-content;
  ${Typography.body_lg_medium}
  color: var(--text-secondary);
  margin-block: 2px 8px;
`;

const TopRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const IconDiv = styled.div`
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Bottom Section styles
const BottomSection = styled.div<Props>`
  display: flex;
  gap: 12px;
  align-items: center;
  padding-inline: ${({ removeTitleSpacing }) => (removeTitleSpacing ? '0px' : '20px')};
  margin-inline: ${({ isInbox, noMargin }) => (isInbox ? '-8px' : noMargin ? '0' : '-20px')};
  padding-bottom: 8px;
`;

const BottomLeftSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BottomRightSection = styled.p<Props>`
  ${Typography.heading_xl_semibold}
  color: var(--text-primary);
  margin-block: 0;
  ${({ applyDottedText }) =>
    applyDottedText &&
    css`
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      word-break: break-all;
    `}
`;

// Add animation styles for header text transitions
const HeaderTexts = styled.div`
  position: relative;
  height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const AnimatedSubTitle = styled(SubTitle)`
  position: absolute;
  left: 0;
  top: 0;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  &.scrolled {
    transform: translateY(-20px);
    opacity: 0;
    pointer-events: none;
  }
`;

const AnimatedTitle = styled(SubTitle)`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  transform: translateY(20px);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  &.scrolled {
    opacity: 1;
    transform: translateY(0);
  }
`;

export {
  Header,
  TopSection,
  SubTitle,
  TopRightSection,
  IconDiv,
  BottomSection,
  BottomLeftSection,
  BottomRightSection,
  HeaderTexts,
  AnimatedSubTitle,
  AnimatedTitle
};
